//*** Lib */

import { createCookie, getCookie, isCookieExist, removeCookie, setCookie } from "../cookies/CookieHandler";
import { COPILOT_STORAGE_KEY } from "../../components/copilot/copilotUtils";
import { ENABLED_MODULE_CODES_STORAGE_KEY } from "../../enums/ProductModuleCodes.ENUM";

const authCookieName = 'MR-AuthUser';
const tokenCookieName = 'MR-Token';
export const POST_LOGIN_REDIRECT_KEY = "moltechr_post_login_redirect";

const AUTH_PAGE_PREFIXES = ["/login", "/forgot-password", "/reset-password"];

export const isAuthPagePath = (path = "") => {
    const value = String(path || "").split("?")[0];
    return AUTH_PAGE_PREFIXES.some((prefix) => value === prefix || value.startsWith(`${prefix}/`));
};

export const getCurrentAppPath = () => {
    try {
        return `${window.location.pathname || "/"}${window.location.search || ""}`;
    } catch {
        return "/";
    }
};

export const savePostLoginRedirect = (path) => {
    const target = path || getCurrentAppPath();
    if (!target || isAuthPagePath(target) || target === "/") return;
    try {
        sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, target);
    } catch {
        /* ignore */
    }
};

export const consumePostLoginRedirect = () => {
    try {
        const saved = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
        sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
        if (!saved || isAuthPagePath(saved)) return null;
        return saved;
    } catch {
        return null;
    }
};

export const clearAuthSession = () => {
    localStorage.setItem("showAdminMenu", false);
    localStorage.removeItem("SecurityPermission");
    localStorage.removeItem(ENABLED_MODULE_CODES_STORAGE_KEY);
    try {
        sessionStorage.removeItem(COPILOT_STORAGE_KEY);
    } catch {
        /* ignore */
    }
    removeCookie(authCookieName);
    removeCookie(tokenCookieName);
};

export const setAuthProps = (data) => {
    const authProps = {
        cookieName: authCookieName,
        cookieValue: data,
        expirationTime: data.sessionTimeout
    }
    createCookie(authProps);
    setTokenProps(data.token);
}

export const getAuthProps = () => {
    return getCookie(authCookieName);
}

export const isAuthorized = () => {
    return isCookieExist(authCookieName);
}

export const setTokenProps = (data) => {
    const tokenProps = {
        cookieName: tokenCookieName,
        cookieValue: data
    }
    setCookie(tokenProps);
}

export const getTokenProps = () => {
    return getCookie(tokenCookieName);
}

/** Clear session and hard-redirect to login, preserving return path when useful. */
export const redirectToLogin = (options = {}) => {
    const { preserveReturnUrl = true, path } = options;
    if (preserveReturnUrl) {
        savePostLoginRedirect(path);
    }
    clearAuthSession();
    if (!isAuthPagePath(getCurrentAppPath())) {
        window.location.href = "/login";
    }
}

export const signOut = () => {
    // Manual logout: do not restore the previous page after next login.
    clearAuthSession();
    try {
        sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    } catch {
        /* ignore */
    }
    window.location.href = "/login";
}

export const IsAuthorizeUser = (allowUserType) => {
    let cookie = getAuthProps();
    let roleType = cookie?.["roleId"] ? Number(cookie?.["roleId"]) : 0;
    if (allowUserType !== undefined) {
        return allowUserType.find(x => x === roleType)
    }
    return ''
}
